import { render, staticRenderFns } from "./rebate-list.vue?vue&type=template&id=d24d225e&scoped=true&"
import script from "./rebate-list.vue?vue&type=script&lang=js&"
export * from "./rebate-list.vue?vue&type=script&lang=js&"
import style0 from "./rebate-list.vue?vue&type=style&index=0&id=d24d225e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24d225e",
  null
  
)

export default component.exports